<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Sliders" class="d-icon d-icon--sliders" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 1a.5.5 0 0 1 .5.5V5a.5.5 0 1 1-1 0V1.5A.5.5 0 0 1 2 1Zm.5 6.5H3a.5.5 0 1 0 0-1H1a.5.5 0 0 0 0 1h.5v3a.5.5 0 1 0 1 0v-3Zm4-1.5a.5.5 0 1 0-1 0v4.5a.5.5 0 1 0 1 0V6ZM6 1a.5.5 0 0 1 .5.5v2H7a.5.5 0 1 1 0 1H5a.5.5 0 0 1 0-1h.5v-2A.5.5 0 0 1 6 1Zm4 6.5h1a.5.5 0 1 1 0 1h-.5v2a.5.5 0 1 1-1 0v-2H9a.5.5 0 0 1 0-1h1ZM10 1a.5.5 0 0 1 .5.5V6a.5.5 0 1 1-1 0V1.5A.5.5 0 0 1 10 1Z" fill="currentColor"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconSliders',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
